import * as r from "node-forge";
import { randomBytes as o } from "tweetnacl";
class a {
  material;
  /**
   * Returns a new `Key` instance, can optionally specify the raw key material
   */
  constructor(e) {
    let t;
    if (e === void 0)
      t = o(32);
    else {
      if (e.length !== 32)
        throw new Error("Invalid key length, must be 32 bytes");
      t = e;
    }
    this.material = t;
  }
  toHex() {
    return r.util.binary.hex.encode(this.material);
  }
}
export {
  a as default
};
//# sourceMappingURL=Key.js.map
